import { render, staticRenderFns } from "./ArqanaHeader.vue?vue&type=template&id=1d2b699c&scoped=true&"
import script from "./ArqanaHeader.vue?vue&type=script&lang=ts&"
export * from "./ArqanaHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ArqanaHeader.vue?vue&type=style&index=0&id=1d2b699c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2b699c",
  null
  
)

export default component.exports